import { _ as at } from "./chunks/Popup.vue_vue_type_style_index_0_lang.Bz5i-LBs.js";
import { _ as it } from "./chunks/Exit.vue_vue_type_style_index_0_lang.PY4SospL.js";
import { _ as ft, c as ht, b as ot, a as ut } from "./chunks/Inliner.vue_vue_type_style_index_0_lang.BR3Id-_j.js";
import { _ as gt, d as dt, g as ct, n as bt } from "./chunks/Note.vue_vue_type_script_setup_true_lang.Dkiikeda.js";
import { S as mt, _ as _t } from "./chunks/Steps.vue_vue_type_style_index_0_lang.DnsnL9hF.js";
import { defaultStyles as yt } from "./p-components.defaultStyles.js";
import { c as Mt, b as St, d as At, a as kt, e as Ht, f as Rt, n as wt, useDefaultStyles as Tt } from "./p-components.useDefaultStyles.js";
import { g as Ft } from "./chunks/Text.vue_vue_type_style_index_0_lang.CqNxQPnN.js";
import { f as It, e as Bt, d as Nt, c as Et, b as Dt, i as Lt, g as Ot, h as Gt, j as zt, p as jt, k as qt, a as Ut, t as Vt, l as $t } from "./chunks/useStore.CDG6wbfK.js";
import { p as Wt } from "./chunks/parseToolData.CdJg7fgv.js";
import { _ as Zt } from "./chunks/Back.vue_vue_type_style_index_0_lang.D3HVPbBh.js";
import { _ as Qt } from "./chunks/Input.vue_vue_type_style_index_0_lang.CzaKyjSR.js";
import { _ as te } from "./chunks/Checkbox.vue_vue_type_style_index_0_lang.w_4wTui5.js";
import { _ as re } from "./chunks/Modal.vue_vue_type_style_index_0_lang.CjTfpaRL.js";
import { _ as ne } from "./chunks/Overlay.vue_vue_type_style_index_0_lang.oYVRTUHy.js";
import { default as se } from "./p-components.SlideDown.js";
import { _ as he } from "./chunks/Terms.vue_vue_type_style_index_0_lang.DvSwaGI1.js";
import { _ as ue } from "./chunks/Tooltip.vue_vue_type_style_index_0_lang.BZsawpJG.js";
import { _ as ge } from "./chunks/XClose.vue_vue_type_style_index_0_lang.B6lW8SK8.js";
function v(t) {
  "@babel/helpers - typeof";
  return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, v(t);
}
var C = /^\s+/, F = /\s+$/;
function s(t, r) {
  if (t = t || "", r = r || {}, t instanceof s)
    return t;
  if (!(this instanceof s))
    return new s(t, r);
  var e = P(t);
  this._originalInput = t, this._r = e.r, this._g = e.g, this._b = e.b, this._a = e.a, this._roundA = Math.round(100 * this._a) / 100, this._format = r.format || e.format, this._gradientType = r.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = e.ok;
}
s.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var r = this.toRgb();
    return (r.r * 299 + r.g * 587 + r.b * 114) / 1e3;
  },
  getLuminance: function() {
    var r = this.toRgb(), e, a, i, n, f, h;
    return e = r.r / 255, a = r.g / 255, i = r.b / 255, e <= 0.03928 ? n = e / 12.92 : n = Math.pow((e + 0.055) / 1.055, 2.4), a <= 0.03928 ? f = a / 12.92 : f = Math.pow((a + 0.055) / 1.055, 2.4), i <= 0.03928 ? h = i / 12.92 : h = Math.pow((i + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * f + 0.0722 * h;
  },
  setAlpha: function(r) {
    return this._a = w(r), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var r = S(this._r, this._g, this._b);
    return {
      h: r.h * 360,
      s: r.s,
      v: r.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var r = S(this._r, this._g, this._b), e = Math.round(r.h * 360), a = Math.round(r.s * 100), i = Math.round(r.v * 100);
    return this._a == 1 ? "hsv(" + e + ", " + a + "%, " + i + "%)" : "hsva(" + e + ", " + a + "%, " + i + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var r = M(this._r, this._g, this._b);
    return {
      h: r.h * 360,
      s: r.s,
      l: r.l,
      a: this._a
    };
  },
  toHslString: function() {
    var r = M(this._r, this._g, this._b), e = Math.round(r.h * 360), a = Math.round(r.s * 100), i = Math.round(r.l * 100);
    return this._a == 1 ? "hsl(" + e + ", " + a + "%, " + i + "%)" : "hsla(" + e + ", " + a + "%, " + i + "%, " + this._roundA + ")";
  },
  toHex: function(r) {
    return A(this._r, this._g, this._b, r);
  },
  toHexString: function(r) {
    return "#" + this.toHex(r);
  },
  toHex8: function(r) {
    return E(this._r, this._g, this._b, this._a, r);
  },
  toHex8String: function(r) {
    return "#" + this.toHex8(r);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(o(this._r, 255) * 100) + "%",
      g: Math.round(o(this._g, 255) * 100) + "%",
      b: Math.round(o(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(o(this._r, 255) * 100) + "%, " + Math.round(o(this._g, 255) * 100) + "%, " + Math.round(o(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(o(this._r, 255) * 100) + "%, " + Math.round(o(this._g, 255) * 100) + "%, " + Math.round(o(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : W[A(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(r) {
    var e = "#" + k(this._r, this._g, this._b, this._a), a = e, i = this._gradientType ? "GradientType = 1, " : "";
    if (r) {
      var n = s(r);
      a = "#" + k(n._r, n._g, n._b, n._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + e + ",endColorstr=" + a + ")";
  },
  toString: function(r) {
    var e = !!r;
    r = r || this._format;
    var a = !1, i = this._a < 1 && this._a >= 0, n = !e && i && (r === "hex" || r === "hex6" || r === "hex3" || r === "hex4" || r === "hex8" || r === "name");
    return n ? r === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (r === "rgb" && (a = this.toRgbString()), r === "prgb" && (a = this.toPercentageRgbString()), (r === "hex" || r === "hex6") && (a = this.toHexString()), r === "hex3" && (a = this.toHexString(!0)), r === "hex4" && (a = this.toHex8String(!0)), r === "hex8" && (a = this.toHex8String()), r === "name" && (a = this.toName()), r === "hsl" && (a = this.toHslString()), r === "hsv" && (a = this.toHsvString()), a || this.toHexString());
  },
  clone: function() {
    return s(this.toString());
  },
  _applyModification: function(r, e) {
    var a = r.apply(null, [this].concat([].slice.call(e)));
    return this._r = a._r, this._g = a._g, this._b = a._b, this.setAlpha(a._a), this;
  },
  lighten: function() {
    return this._applyModification(G, arguments);
  },
  brighten: function() {
    return this._applyModification(z, arguments);
  },
  darken: function() {
    return this._applyModification(j, arguments);
  },
  desaturate: function() {
    return this._applyModification(D, arguments);
  },
  saturate: function() {
    return this._applyModification(L, arguments);
  },
  greyscale: function() {
    return this._applyModification(O, arguments);
  },
  spin: function() {
    return this._applyModification(q, arguments);
  },
  _applyCombination: function(r, e) {
    return r.apply(null, [this].concat([].slice.call(e)));
  },
  analogous: function() {
    return this._applyCombination($, arguments);
  },
  complement: function() {
    return this._applyCombination(U, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(K, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(V, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(H, [3]);
  },
  tetrad: function() {
    return this._applyCombination(H, [4]);
  }
};
s.fromRatio = function(t, r) {
  if (v(t) == "object") {
    var e = {};
    for (var a in t)
      t.hasOwnProperty(a) && (a === "a" ? e[a] = t[a] : e[a] = _(t[a]));
    t = e;
  }
  return s(t, r);
};
function P(t) {
  var r = {
    r: 0,
    g: 0,
    b: 0
  }, e = 1, a = null, i = null, n = null, f = !1, h = !1;
  return typeof t == "string" && (t = Q(t)), v(t) == "object" && (p(t.r) && p(t.g) && p(t.b) ? (r = I(t.r, t.g, t.b), f = !0, h = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : p(t.h) && p(t.s) && p(t.v) ? (a = _(t.s), i = _(t.v), r = N(t.h, a, i), f = !0, h = "hsv") : p(t.h) && p(t.s) && p(t.l) && (a = _(t.s), n = _(t.l), r = B(t.h, a, n), f = !0, h = "hsl"), t.hasOwnProperty("a") && (e = t.a)), e = w(e), {
    ok: f,
    format: t.format || h,
    r: Math.min(255, Math.max(r.r, 0)),
    g: Math.min(255, Math.max(r.g, 0)),
    b: Math.min(255, Math.max(r.b, 0)),
    a: e
  };
}
function I(t, r, e) {
  return {
    r: o(t, 255) * 255,
    g: o(r, 255) * 255,
    b: o(e, 255) * 255
  };
}
function M(t, r, e) {
  t = o(t, 255), r = o(r, 255), e = o(e, 255);
  var a = Math.max(t, r, e), i = Math.min(t, r, e), n, f, h = (a + i) / 2;
  if (a == i)
    n = f = 0;
  else {
    var u = a - i;
    switch (f = h > 0.5 ? u / (2 - a - i) : u / (a + i), a) {
      case t:
        n = (r - e) / u + (r < e ? 6 : 0);
        break;
      case r:
        n = (e - t) / u + 2;
        break;
      case e:
        n = (t - r) / u + 4;
        break;
    }
    n /= 6;
  }
  return {
    h: n,
    s: f,
    l: h
  };
}
function B(t, r, e) {
  var a, i, n;
  t = o(t, 360), r = o(r, 100), e = o(e, 100);
  function f(g, m, d) {
    return d < 0 && (d += 1), d > 1 && (d -= 1), d < 1 / 6 ? g + (m - g) * 6 * d : d < 1 / 2 ? m : d < 2 / 3 ? g + (m - g) * (2 / 3 - d) * 6 : g;
  }
  if (r === 0)
    a = i = n = e;
  else {
    var h = e < 0.5 ? e * (1 + r) : e + r - e * r, u = 2 * e - h;
    a = f(u, h, t + 1 / 3), i = f(u, h, t), n = f(u, h, t - 1 / 3);
  }
  return {
    r: a * 255,
    g: i * 255,
    b: n * 255
  };
}
function S(t, r, e) {
  t = o(t, 255), r = o(r, 255), e = o(e, 255);
  var a = Math.max(t, r, e), i = Math.min(t, r, e), n, f, h = a, u = a - i;
  if (f = a === 0 ? 0 : u / a, a == i)
    n = 0;
  else {
    switch (a) {
      case t:
        n = (r - e) / u + (r < e ? 6 : 0);
        break;
      case r:
        n = (e - t) / u + 2;
        break;
      case e:
        n = (t - r) / u + 4;
        break;
    }
    n /= 6;
  }
  return {
    h: n,
    s: f,
    v: h
  };
}
function N(t, r, e) {
  t = o(t, 360) * 6, r = o(r, 100), e = o(e, 100);
  var a = Math.floor(t), i = t - a, n = e * (1 - r), f = e * (1 - i * r), h = e * (1 - (1 - i) * r), u = a % 6, g = [e, f, n, n, h, e][u], m = [h, e, e, f, n, n][u], d = [n, n, h, e, e, f][u];
  return {
    r: g * 255,
    g: m * 255,
    b: d * 255
  };
}
function A(t, r, e, a) {
  var i = [b(Math.round(t).toString(16)), b(Math.round(r).toString(16)), b(Math.round(e).toString(16))];
  return a && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function E(t, r, e, a, i) {
  var n = [b(Math.round(t).toString(16)), b(Math.round(r).toString(16)), b(Math.round(e).toString(16)), b(T(a))];
  return i && n[0].charAt(0) == n[0].charAt(1) && n[1].charAt(0) == n[1].charAt(1) && n[2].charAt(0) == n[2].charAt(1) && n[3].charAt(0) == n[3].charAt(1) ? n[0].charAt(0) + n[1].charAt(0) + n[2].charAt(0) + n[3].charAt(0) : n.join("");
}
function k(t, r, e, a) {
  var i = [b(T(a)), b(Math.round(t).toString(16)), b(Math.round(r).toString(16)), b(Math.round(e).toString(16))];
  return i.join("");
}
s.equals = function(t, r) {
  return !t || !r ? !1 : s(t).toRgbString() == s(r).toRgbString();
};
s.random = function() {
  return s.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function D(t, r) {
  r = r === 0 ? 0 : r || 10;
  var e = s(t).toHsl();
  return e.s -= r / 100, e.s = y(e.s), s(e);
}
function L(t, r) {
  r = r === 0 ? 0 : r || 10;
  var e = s(t).toHsl();
  return e.s += r / 100, e.s = y(e.s), s(e);
}
function O(t) {
  return s(t).desaturate(100);
}
function G(t, r) {
  r = r === 0 ? 0 : r || 10;
  var e = s(t).toHsl();
  return e.l += r / 100, e.l = y(e.l), s(e);
}
function z(t, r) {
  r = r === 0 ? 0 : r || 10;
  var e = s(t).toRgb();
  return e.r = Math.max(0, Math.min(255, e.r - Math.round(255 * -(r / 100)))), e.g = Math.max(0, Math.min(255, e.g - Math.round(255 * -(r / 100)))), e.b = Math.max(0, Math.min(255, e.b - Math.round(255 * -(r / 100)))), s(e);
}
function j(t, r) {
  r = r === 0 ? 0 : r || 10;
  var e = s(t).toHsl();
  return e.l -= r / 100, e.l = y(e.l), s(e);
}
function q(t, r) {
  var e = s(t).toHsl(), a = (e.h + r) % 360;
  return e.h = a < 0 ? 360 + a : a, s(e);
}
function U(t) {
  var r = s(t).toHsl();
  return r.h = (r.h + 180) % 360, s(r);
}
function H(t, r) {
  if (isNaN(r) || r <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var e = s(t).toHsl(), a = [s(t)], i = 360 / r, n = 1; n < r; n++)
    a.push(s({
      h: (e.h + n * i) % 360,
      s: e.s,
      l: e.l
    }));
  return a;
}
function V(t) {
  var r = s(t).toHsl(), e = r.h;
  return [s(t), s({
    h: (e + 72) % 360,
    s: r.s,
    l: r.l
  }), s({
    h: (e + 216) % 360,
    s: r.s,
    l: r.l
  })];
}
function $(t, r, e) {
  r = r || 6, e = e || 30;
  var a = s(t).toHsl(), i = 360 / e, n = [s(t)];
  for (a.h = (a.h - (i * r >> 1) + 720) % 360; --r; )
    a.h = (a.h + i) % 360, n.push(s(a));
  return n;
}
function K(t, r) {
  r = r || 6;
  for (var e = s(t).toHsv(), a = e.h, i = e.s, n = e.v, f = [], h = 1 / r; r--; )
    f.push(s({
      h: a,
      s: i,
      v: n
    })), n = (n + h) % 1;
  return f;
}
s.mix = function(t, r, e) {
  e = e === 0 ? 0 : e || 50;
  var a = s(t).toRgb(), i = s(r).toRgb(), n = e / 100, f = {
    r: (i.r - a.r) * n + a.r,
    g: (i.g - a.g) * n + a.g,
    b: (i.b - a.b) * n + a.b,
    a: (i.a - a.a) * n + a.a
  };
  return s(f);
};
s.readability = function(t, r) {
  var e = s(t), a = s(r);
  return (Math.max(e.getLuminance(), a.getLuminance()) + 0.05) / (Math.min(e.getLuminance(), a.getLuminance()) + 0.05);
};
s.isReadable = function(t, r, e) {
  var a = s.readability(t, r), i, n;
  switch (n = !1, i = Y(e), i.level + i.size) {
    case "AAsmall":
    case "AAAlarge":
      n = a >= 4.5;
      break;
    case "AAlarge":
      n = a >= 3;
      break;
    case "AAAsmall":
      n = a >= 7;
      break;
  }
  return n;
};
s.mostReadable = function(t, r, e) {
  var a = null, i = 0, n, f, h, u;
  e = e || {}, f = e.includeFallbackColors, h = e.level, u = e.size;
  for (var g = 0; g < r.length; g++)
    n = s.readability(t, r[g]), n > i && (i = n, a = s(r[g]));
  return s.isReadable(t, a, {
    level: h,
    size: u
  }) || !f ? a : (e.includeFallbackColors = !1, s.mostReadable(t, ["#fff", "#000"], e));
};
var x = s.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, W = s.hexNames = X(x);
function X(t) {
  var r = {};
  for (var e in t)
    t.hasOwnProperty(e) && (r[t[e]] = e);
  return r;
}
function w(t) {
  return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function o(t, r) {
  Z(t) && (t = "100%");
  var e = J(t);
  return t = Math.min(r, Math.max(0, parseFloat(t))), e && (t = parseInt(t * r, 10) / 100), Math.abs(t - r) < 1e-6 ? 1 : t % r / parseFloat(r);
}
function y(t) {
  return Math.min(1, Math.max(0, t));
}
function l(t) {
  return parseInt(t, 16);
}
function Z(t) {
  return typeof t == "string" && t.indexOf(".") != -1 && parseFloat(t) === 1;
}
function J(t) {
  return typeof t == "string" && t.indexOf("%") != -1;
}
function b(t) {
  return t.length == 1 ? "0" + t : "" + t;
}
function _(t) {
  return t <= 1 && (t = t * 100 + "%"), t;
}
function T(t) {
  return Math.round(parseFloat(t) * 255).toString(16);
}
function R(t) {
  return l(t) / 255;
}
var c = function() {
  var t = "[-\\+]?\\d+%?", r = "[-\\+]?\\d*\\.\\d+%?", e = "(?:" + r + ")|(?:" + t + ")", a = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?", i = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(e),
    rgb: new RegExp("rgb" + a),
    rgba: new RegExp("rgba" + i),
    hsl: new RegExp("hsl" + a),
    hsla: new RegExp("hsla" + i),
    hsv: new RegExp("hsv" + a),
    hsva: new RegExp("hsva" + i),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function p(t) {
  return !!c.CSS_UNIT.exec(t);
}
function Q(t) {
  t = t.replace(C, "").replace(F, "").toLowerCase();
  var r = !1;
  if (x[t])
    t = x[t], r = !0;
  else if (t == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var e;
  return (e = c.rgb.exec(t)) ? {
    r: e[1],
    g: e[2],
    b: e[3]
  } : (e = c.rgba.exec(t)) ? {
    r: e[1],
    g: e[2],
    b: e[3],
    a: e[4]
  } : (e = c.hsl.exec(t)) ? {
    h: e[1],
    s: e[2],
    l: e[3]
  } : (e = c.hsla.exec(t)) ? {
    h: e[1],
    s: e[2],
    l: e[3],
    a: e[4]
  } : (e = c.hsv.exec(t)) ? {
    h: e[1],
    s: e[2],
    v: e[3]
  } : (e = c.hsva.exec(t)) ? {
    h: e[1],
    s: e[2],
    v: e[3],
    a: e[4]
  } : (e = c.hex8.exec(t)) ? {
    r: l(e[1]),
    g: l(e[2]),
    b: l(e[3]),
    a: R(e[4]),
    format: r ? "name" : "hex8"
  } : (e = c.hex6.exec(t)) ? {
    r: l(e[1]),
    g: l(e[2]),
    b: l(e[3]),
    format: r ? "name" : "hex"
  } : (e = c.hex4.exec(t)) ? {
    r: l(e[1] + "" + e[1]),
    g: l(e[2] + "" + e[2]),
    b: l(e[3] + "" + e[3]),
    a: R(e[4] + "" + e[4]),
    format: r ? "name" : "hex8"
  } : (e = c.hex3.exec(t)) ? {
    r: l(e[1] + "" + e[1]),
    g: l(e[2] + "" + e[2]),
    b: l(e[3] + "" + e[3]),
    format: r ? "name" : "hex"
  } : !1;
}
function Y(t) {
  var r, e;
  return t = t || {
    level: "AA",
    size: "small"
  }, r = (t.level || "AA").toUpperCase(), e = (t.size || "small").toLowerCase(), r !== "AA" && r !== "AAA" && (r = "AA"), e !== "small" && e !== "large" && (e = "small"), {
    level: r,
    size: e
  };
}
function tt(t) {
  const r = s(t);
  return {
    isDark: () => r.getLuminance() <= 0.5,
    darken: (f) => r.darken(f).toString(),
    lighten: (f) => r.lighten(f).toString(),
    setAlpha: (f) => r.setAlpha(f).toString()
  };
}
export {
  Zt as Back,
  te as Checkbox,
  it as Exit,
  ft as Inliner,
  Qt as Input,
  re as Modal,
  gt as Note,
  ne as Overlay,
  at as Popup,
  se as SlideDown,
  mt as StepState,
  _t as Steps,
  he as Terms,
  ue as Tooltip,
  ge as XClose,
  It as appendEm,
  Bt as appendPercent,
  Nt as appendPx,
  ht as calcMarginByDevice,
  ot as calcPlacementByDevice,
  ut as calcWidthByDevice,
  Et as camelToSnakeCase,
  tt as colorHelper,
  Mt as defaultBackgroundStyles,
  St as defaultButtonStyles,
  At as defaultColorStyles,
  kt as defaultFontsStyles,
  Ht as defaultInlinerBackgroundStyles,
  Rt as defaultOverlayStyles,
  yt as defaultStyles,
  dt as devicePositionedLayouts,
  Ft as getButtonActionType,
  Dt as getCornerRadius,
  Lt as getPaddingLiteral,
  Ot as getPluralized,
  ct as getTransitionName,
  Gt as hexToRgba,
  zt as isObj,
  wt as noteDefaultColorsStyles,
  bt as noteModuleKindToComponentMap,
  jt as padNumber,
  qt as parseTimeLeft,
  Wt as parseToolData,
  Ut as toKebabCase,
  Vt as toPascalCase,
  $t as toTitleCase,
  Tt as useDefaultStyles
};
//# sourceMappingURL=p-components.main.js.map
